export enum AwardTypeEnum {
    BADGE       = 1,
    MONEY       = 2,
}
